import React from 'react';
import { useHistory } from 'react-router-dom';
import { clearAdminSession, getAdminRole, getAuthUser } from '../lib/api';

function AccountFooter() {
  const history = useHistory();
  const role = getAdminRole();
  const user = getAuthUser();
  const label = user?.name || user?.email || role || 'guest';
  const initial = String(label).charAt(0).toUpperCase();

  function logout() {
    clearAdminSession();
    history.push('/login');
  }

  return (
    <div className="app-account">
      <div className="app-account__identity">
        <div className="app-account__avatar">{initial}</div>
        <div className="app-account__meta">
          <span className="app-account__role">{label}</span>
          <span className="app-account__hint">{role || 'signed in'}</span>
        </div>
      </div>
      <button type="button" className="app-account__logout" onClick={logout} title="Log out">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
        </svg>
      </button>
    </div>
  );
}

export default AccountFooter;
